import React from "react";
import { connect } from "react-redux";
import { Button, Card, CardBody, Col, DropdownItem, Row, Toast, ToastHeader } from "reactstrap";
import {
  ActionsRow,
  FixedDropDownButton,
  HorizontalLoader,
  Icon,
  InfiniteScroll,
  Loader,
  modal,
  utils,
} from "@mc/mc-legacy";
import QSignAdminApi from "../../../api/gen/qsign/QSignAdminApi";
import { DetailValue } from "@mc/mc-legacy";
import "./SignConfigurationsList.scss";
import * as findCombinationsActions from "../../../actions/findCombinationsActions";
import KombinaceForm from "../../forms/KombinaceForm";
import * as SignTimestampLevelInfo from "../../../api/SignTimestampLevelInfo";
import * as SealTimestampLevelInfo from "../../../api/SealTimestampLevelInfo";
import * as SealingLevelInfo from "../../../api/SealingLevelInfo";
import * as SigningLevelInfo from "../../../api/SigningLevelInfo";

/**
 * Šablony - výpis / editace.
 */
class KombinaceList extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    this.fetchData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.fetchData(nextProps);
  }

  fetchData = (props) => {
    props.dispatch(findCombinationsActions.fetchCombinationsIfNeeded());
  };
  handleDeleteConfig = (item) => {
    const { dispatch } = this.props;
    dispatch(
      modal.ModalActions.showConfirm(
        "Potvrzení smazání",
        "Opravdu chcete smazat konfiguraci " + item.name + "?",
        () =>
          QSignAdminApi.deleteTypesCombination(item.id)
            .then(() => {
              dispatch(findCombinationsActions.invalidate());
            }),
        null,
        "Potvrdit"
      )
    );
  };

  handleEditConfig = (item) => {
    const codes = this.props.KombinaceList.filteredRows.map((a) => a.code);
    codes.splice(codes.indexOf(item.code), 1);
    const { dispatch } = this.props;
    dispatch(
      modal.ModalActions.show(
        KombinaceForm,
        {
          onSubmit: (data) => {
            delete data.codes;
            return QSignAdminApi.updateTypesCombination(data);
          },
          onSubmitSuccess: (result, dispatch) => {
            dispatch(modal.ModalActions.hide());
            dispatch(findCombinationsActions.invalidate());
          },
          initialValues: {
            ...item,
            codes,
          },
        },
        "Úprava konfigurace",
        {}
      )
    );
  };
  handleNovy = () => {
    const { dispatch } = this.props;
    const codes = this.props.KombinaceList.filteredRows.map((a) => a.code);
    dispatch(
      modal.ModalActions.show(
        KombinaceForm,
        {
          onSubmit: (data) => {
            delete data.codes;
            return QSignAdminApi.addTypesCombination(data);
          },
          onSubmitSuccess: (result, dispatch) => {
            dispatch(modal.ModalActions.hide());
            dispatch(findCombinationsActions.invalidate());
          },
          initialValues: {
            signatureLevel: "NONE",
            signatureTimestampLevel: "NONE",
            sealLevel: "NONE",
            sealTimeStampLevel: "NONE",
            codes,
          },
        },
        "Úprava konfigurace",
        {}
      )
    );
  };
  renderItem = (item, key) => {
    return (
      <Card key={key}>
        <CardBody>
          <ActionsRow actions={this.renderActions(item)}>
            <Row>
              <Col xs={12} md={2}>
                <DetailValue textOverflow label="Název">
                  {item.name}
                </DetailValue>
              </Col>
              <Col xs={6} md={2}>
                <DetailValue textOverflow label="Kód">
                  {item.code}
                </DetailValue>
              </Col>
              <Col xs={6} md={2}>
                <DetailValue textOverflow label="Úroveň podpisu">
                  {SigningLevelInfo.getCaption(item.signatureLevel)}
                </DetailValue>
              </Col>
              <Col xs={6} md={2}>
                <DetailValue textOverflow label="Úroveň časového razítka podpisu">
                  {SignTimestampLevelInfo.getCaption(item.signatureTimestampLevel)}
                </DetailValue>
              </Col>
              <Col xs={6} md={2}>
                <DetailValue textOverflow label="Úroveň pečetě">
                  {SealingLevelInfo.getCaption(item.sealLevel)}
                </DetailValue>
              </Col>
              <Col xs={6} md={2}>
                <DetailValue textOverflow label="Úroveň časového razítka pečetě">
                  {SealTimestampLevelInfo.getCaption(item.sealTimeStampLevel)}
                </DetailValue>
              </Col>
            </Row>
          </ActionsRow>
        </CardBody>
      </Card>
    );
  };

  renderActions = (item) => {
    return (
      <Col className="item-actions">
        <FixedDropDownButton color="action" noCaret title={<Icon icon="ellipsis-v" className="item-actions-icon" />}>
          <DropdownItem key="1" onClick={() => this.handleEditConfig(item)}>
            Upravit
          </DropdownItem>
          <DropdownItem key="2" onClick={() => this.handleDeleteConfig(item)}>
            Smazat
          </DropdownItem>
        </FixedDropDownButton>
      </Col>
    );
  };

  render() {
    const { KombinaceList } = this.props;

    if (!KombinaceList) {
      return <Loader />;
    }

    return (
      <div>
        <Row className="d-flex mt-5">
          <Col className="ml-1">
            <h2>{"Seznam kombinací"}</h2>
          </Col>
          <Col className="d-flex">
            <Button color="primary" className="mr-3" style={{ marginLeft: "auto" }} onClick={this.handleNovy}>
              Přidat
            </Button>
          </Col>
        </Row>
        <InfiniteScroll className="config-list" bordered>
          {KombinaceList.isFetching && <HorizontalLoader key={'loader'} hover />}
          {KombinaceList.rows.length > 0
            ? KombinaceList.rows.map((item, key) => {
                return this.renderItem(item, key);
              })
            : !KombinaceList.isFetching && (
                <Row className="justify-content-center">
                  <h4>Není definována žádná Kombinace</h4>
                </Row>
              )}
        </InfiniteScroll>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    KombinaceList: utils.storeFromArea(state, findCombinationsActions.KOMBINACE_LIST),
  };
}

export default connect(mapStateToProps)(KombinaceList);
